import { render, staticRenderFns } from "./LinkedAccountForm.vue?vue&type=template&id=226b1db8&"
import script from "./LinkedAccountForm.vue?vue&type=script&lang=js&"
export * from "./LinkedAccountForm.vue?vue&type=script&lang=js&"
import style0 from "./LinkedAccountForm.vue?vue&type=style&index=0&id=226b1db8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports